import React from 'react';
import Helmet from 'react-helmet';
import Credits from 'containers/Credits';
import { IS_ARABIC } from '../../constants';

export default ({ match: { params = {} } }) => {
  return (
    <>
      <Helmet>
        <html lang={IS_ARABIC ? 'ar' : 'en'} dir={IS_ARABIC ? 'rtl' : 'ltr'} />
      </Helmet>
      <Credits language={params.lang} />
    </>
  );
};
